import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CourseOutlineConfig from 'legacy-src/utility/CourseOutlineConfig';
import Tags from './components/Tags';
import Toggle from './components/Toggle';
import './index.scss';

/**
 * Draws item tags panel
 * */
class ItemTags extends PureComponent {
  static displayName = 'ItemTags';

  static propTypes = {
    /**
     * ItemId to load item tags
     * */
    itemId: PropTypes.string.isRequired,
    /*
     * Course outline config object provided by the wrapper
     * */
    courseOutlineConfig: PropTypes.object.isRequired,
    /**
     * Current item reference
     * */
    itemReference: PropTypes.string,
    /**
     * The type of the item; Used to determine how to show the correct answers.
     * */
    itemType: PropTypes.string.isRequired,

    questionDetailsToogleRationale: PropTypes.func,

    /**
     * Optional view spec to use. If null, it defaults to the legacy view spec. Final Exams show a different set of
     * tags than the default view, so this allows passing different options. utility/ItemTags/state/actions.js has an
     * enum-like object with the names of these.
     */
    isFinalExam: PropTypes.bool,
    handleToggleExpansion: PropTypes.func,
    onLoad: PropTypes.func,
  };

  static defaultProps = {
    itemReference: '',
    itemType: 'unknown',
    questionDetailsToogleRationale: () => {},
    isFinalExam: false,
    handleToggleExpansion: (toggleStatus) => toggleStatus,
    onLoad: () => {},
  };

  constructor(props) {
    super(props);

    this.onToggleChange = this.onToggleChange.bind(this);
    this.onToggleUpdate = this.onToggleUpdate.bind(this);
  }

  componentDidMount() {
    this.itemTagsFocusElement = document.querySelector('.ItemMetadata--focus');
    this.itemTagsToggleElement = document.querySelector(
      '.ItemMetadata__toggle_button span',
    );
  }

  /**
   * Toggle change event
   * @param {bool} isExpanded
   * */
  onToggleChange(isExpanded) {
    const { handleToggleExpansion, isFinalExam } = this.props;
    !isFinalExam && handleToggleExpansion && handleToggleExpansion(isExpanded);
  }

  /*
   * Toggle update event
   * @param {bool} isExpanded
   * */
  onToggleUpdate(isExpanded) {
    if (isExpanded) {
      this.itemTagsToggleElement.blur();
      setTimeout(() => {
        this.itemTagsFocusElement.focus({
          preventScroll: true,
        });
      }, 100);
    }
  }

  render() {
    const {
      itemId,
      courseOutlineConfig,
      location,
      params,
      questionDetailsToogleRationale,
      isFinalExam,
      showGrayTopRightBarPreview,
      onLoad,
    } = this.props;
    const subunitLabel =
      (courseOutlineConfig.data || {}).subunitLabel || 'Subunit';

    const isPPC =
      location && location.state && location.state.assignmentType === 'ppc';

    return (
      <Toggle
        onChange={this.onToggleChange}
        onUpdate={this.onToggleUpdate}
        showGrayTopRightBarPreview={showGrayTopRightBarPreview}
      >
        <Tags
          onLoad={onLoad}
          subjectType={isPPC ? 'fym' : 'qb'}
          itemId={itemId}
          subunitLabel={subunitLabel}
          params={params}
          questionDetailsToogleRationale={questionDetailsToogleRationale}
          isFinalExam={isFinalExam}
        />
      </Toggle>
    );
  }
}

export default CourseOutlineConfig(ItemTags);
